import React from "react";
import { IoRestaurant } from "react-icons/io5";
import { BiDrink } from "react-icons/bi";

export default function ServiceTimeOfClub({ foodserving, alcoholserving }) {
  return (
    <>
      <div className="d-flex flex-column gap-2 align-items-start">
        <span className="">Service Time</span>
        <div className="bid-new-card-text-section-food-time">
          {foodserving !== "" && (
            <p>
              {" "}
              <IoRestaurant /> {foodserving || "--"}
            </p>
          )}
          {alcoholserving !== "" && (
            <p>
              {" "}
              <BiDrink /> {alcoholserving || "--"}
            </p>
          )}
        </div>
      </div>
    </>
  );
}
